<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="!submitting"
  [dismissableMask]="false"
  [draggable]="false"
  [style]="{ width: 'min(560px, 96vw)' }"
  styleClass="company-new-order-dialog"
  (onHide)="onHide()"
  header="New order"
>
  <div *ngIf="loading" class="new-order-loading">
    <i class="pi pi-spin pi-spinner me-2"></i> Loading order details…
  </div>

  <div *ngIf="!loading && !order" class="new-order-empty">
    Order not found or was already removed.
  </div>

  <div *ngIf="!loading && order" class="new-order-shell">
    <div class="order-hero">
      <div>
        <div class="order-hero__title">{{ serviceLabel }}</div>
        <div class="order-hero__meta">
          <span class="order-hero__badge">{{ order.status || 'pending' }}</span>
          <span *ngIf="isProductOrder">Product order</span>
          <span *ngIf="isScheduledAppointment">Appointment</span>
        </div>
        <div class="order-id-row" *ngIf="order?.id">
          <span class="order-id-label">Order ID</span>
          <code class="order-id-value">{{ order.id }}</code>
          <button
            type="button"
            class="order-id-copy"
            (click)="copyOrderId()"
            title="Copy order ID"
          >
            <i class="bi bi-clipboard"></i>
          </button>
        </div>
      </div>
      <div class="order-hero__price">
        <div class="order-hero__price-value">{{ order.price | number: '1.2-2' }} QAR</div>
        <div class="order-hero__price-sub">{{ (order.paymentWay || 'cash') }}</div>
      </div>
    </div>

    <div class="detail-card" *ngIf="isProductOrder">
      <h6 class="section-label"><i class="bi bi-box-seam"></i> Product</h6>
      <div class="product-row">
        <img *ngIf="order.image" [src]="order.image" alt="" class="product-thumb" />
        <div>
          <div class="product-title">{{ order.productBrand || serviceLabel }}</div>
          <div class="meta-line" *ngIf="order.productSize">Size: {{ order.productSize }}</div>
          <div class="meta-line" *ngIf="order.productQty">
            Qty: {{ order.productQty }}
            <span *ngIf="order.unitPrice"> × {{ order.unitPrice }} QAR</span>
          </div>
          <div class="meta-line" *ngIf="order.serviceFee != null">
            Service fee: {{ order.serviceFee }} QAR
          </div>
          <div class="meta-line meta-line--accent" *ngIf="estimatedDeliveryLabel">
            Customer estimate: {{ estimatedDeliveryLabel }}
          </div>
          <div class="meta-line" *ngIf="order.notes">Notes: {{ order.notes }}</div>
        </div>
      </div>
    </div>

    <div class="detail-card" *ngIf="!isProductOrder && order.selectedOptions?.length">
      <h6 class="section-label"><i class="bi bi-list-check"></i> Selected options</h6>
      <ul class="mb-0 ps-3">
        <li *ngFor="let opt of order.selectedOptions">
          {{ opt.name || opt.optionName }}
          <span *ngIf="opt.price != null"> — {{ opt.price }} QAR</span>
        </li>
      </ul>
    </div>

    <div class="detail-card" *ngIf="order.form">
      <h6 class="section-label"><i class="bi bi-card-text"></i> Request details</h6>
      <div class="meta-line" *ngFor="let item of order.form | keyvalue">
        <strong>{{ item.key }}:</strong> {{ item.value }}
      </div>
    </div>

    <div class="detail-card">
      <h6 class="section-label"><i class="bi bi-person"></i> Customer</h6>
      <div class="customer-name">
        {{ order.customerName || (customer?.fname + ' ' + customer?.lname) || '—' }}
      </div>
      <div class="meta-line" *ngIf="customerPhoneDisplay as phone">
        {{ phone }}
      </div>
      <div class="meta-line" *ngIf="customer?.email">{{ customer.email }}</div>
      <div class="customer-contact-actions" *ngIf="customerPhoneDisplay">
        <button type="button" class="contact-btn" (click)="callCustomer()">
          <i class="bi bi-telephone"></i> Call
        </button>
        <button
          type="button"
          class="contact-btn contact-btn--wa"
          *ngIf="hasCustomerWhatsApp"
          (click)="openCustomerWhatsApp()"
        >
          <i class="bi bi-whatsapp"></i> WhatsApp
        </button>
      </div>
    </div>

    <div class="detail-card" *ngIf="order.locations?.length">
      <h6 class="section-label"><i class="bi bi-geo-alt"></i> Location</h6>
      <div class="meta-line" *ngFor="let loc of order.locations; let i = index">
        Point {{ i + 1 }}: {{ loc.lat | number: '1.5-5' }}, {{ loc.lng | number: '1.5-5' }}
      </div>
    </div>

    <div class="detail-card schedule-card" *ngIf="requestedScheduleLabel || isScheduledAppointment || requestedDayLabel">
      <h6 class="section-label">
        <i class="bi bi-calendar2-check"></i>
        {{ isScheduledAppointment ? 'Appointment request' : 'Requested time' }}
      </h6>
      <div class="schedule-badge" *ngIf="isScheduledAppointment">Scheduled appointment</div>
      <div class="meta-line meta-line--accent" *ngIf="requestedScheduleLabel">
        <strong>Window:</strong> {{ requestedScheduleLabel }}
      </div>
      <div class="meta-line" *ngIf="requestedDayLabel">
        <strong>Requested day:</strong> {{ requestedDayLabel }}
      </div>
      <div class="meta-line" *ngIf="order.requested_day_period">
        <strong>Period:</strong> {{ order.requested_day_period | titlecase }}
      </div>
      <p class="hint mb-0 mt-2" *ngIf="isScheduledAppointment">
        Confirm an exact time with the customer, then set “Go to customer” below within that day.
      </p>
    </div>

    <div class="detail-card">
      <h6 class="section-label"><i class="bi bi-people"></i> Assign provider *</h6>
      <div class="provider-list">
        <button
          type="button"
          class="provider-item"
          *ngFor="let provider of providers"
          [class.selected]="selectedProvider?.id === provider.id"
          (click)="selectProvider(provider)"
        >
          <span class="avatar">
            <img *ngIf="provider.logo" [src]="provider.logo" alt="" />
            <span *ngIf="!provider.logo">
              {{ (provider.fname || '?')[0] }}{{ (provider.lname || '')[0] }}
            </span>
          </span>
          <span class="name">{{ providerLabel(provider) }}</span>
          <i class="bi bi-check-circle-fill check" *ngIf="selectedProvider?.id === provider.id"></i>
        </button>
        <div class="meta-line" *ngIf="!providers?.length">
          No providers found for this company.
        </div>
      </div>
    </div>

    <div class="detail-card" *ngIf="needsArrivalTime">
      <h6 class="section-label"><i class="bi bi-clock"></i> Go to customer *</h6>
      <p class="hint">
        Set the date and time the provider should go to the customer. Both will be notified.
      </p>
      <div class="datetime-grid">
        <div>
          <label class="field-label">Date</label>
          <p-calendar
            [(ngModel)]="arrivalDate"
            [showIcon]="true"
            dateFormat="dd M yy"
            [minDate]="minArrivalDate"
            (onSelect)="syncArrivalFromParts()"
            styleClass="w-100"
            inputStyleClass="form-control"
            placeholder="Select date"
          ></p-calendar>
        </div>
        <div>
          <label class="field-label">Time</label>
          <input
            class="form-control"
            [(ngModel)]="arrivalTime"
            [ngxTimepicker]="arrivalTimePicker"
            (ngModelChange)="syncArrivalFromParts()"
            readonly
            placeholder="Select time"
          />
          <ngx-material-timepicker
            #arrivalTimePicker
            (timeSet)="onArrivalTimeSet($event)"
          ></ngx-material-timepicker>
        </div>
      </div>
      <div class="selected-summary" *ngIf="arrivalAt">
        Selected: <strong>{{ formatArrival(arrivalAt) }}</strong>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Reject"
        icon="pi pi-times"
        class="p-button-danger p-button-outlined"
        [disabled]="submitting || !order || order.status === 'declined'"
        (click)="rejectOrder()"
      ></button>
      <div class="dialog-footer__actions">
        <button
          pButton
          type="button"
          label="Later"
          class="p-button-text"
          [disabled]="submitting"
          (click)="onHide()"
        ></button>
        <button
          pButton
          type="button"
          label="Accept & assign"
          icon="pi pi-check"
          class="p-button-success"
          [loading]="submitting"
          [disabled]="!canConfirmAssign || submitting"
          (click)="acceptAndAssign()"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
